import { render, staticRenderFns } from "./IngressTab.vue?vue&type=template&id=44569083&scoped=true&"
import script from "./IngressTab.vue?vue&type=script&lang=js&"
export * from "./IngressTab.vue?vue&type=script&lang=js&"
import style0 from "./IngressTab.vue?vue&type=style&index=0&id=44569083&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44569083",
  null
  
)

export default component.exports